import React from 'react';
// import { Link } from 'react-router-dom'; // Removed unused import
// import AnimatedSection from '../components/AnimatedSection'; // Removed unused import
import HeroAbout from '../components/HeroAbout';
import AboutSection from '../components/AboutSection';
import { useLanguage, t } from '../utils/i18n';
// import { glassStyles } from '../utils/glassStyles'; // Import glass styles
import { motion } from 'framer-motion'; // Added motion import

const AboutPage = () => {
  const { language } = useLanguage(); // Use language hook

  return (
    <div className="relative min-h-screen">
      {/* New Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#F2EBE6] to-[#D5BCA3] z-0" />

      {/* Content relative to background */}
      <div className="relative z-10">
        <HeroAbout 
          title={t('about.hero.title', language.code)}
          subtitle={t('about.hero.subtitle', language.code)}
        />
        
        {/* Separator */}
        <div className="h-[2px] bg-gradient-to-r from-transparent via-neutral-800 to-transparent opacity-50" />

        {/* Container for About Sections - Removed outer padding and glass from here */}
        <div className="container-custom py-0"> {/* Removed py-12, sections will have their own */}
          {/* History Section - Outer glass div removed */}
          {/* <div className="p-8 rounded-[2rem] mb-12 bg-white/10 backdrop-blur-md border border-white/20 shadow-lg"> */}
          <AboutSection 
            title={t('about.history.title', language.code)}
            content={
              <div>
                <p className="mb-4">
                  {t('about.history.p1', language.code)}
                </p>
                <p>
                  {t('about.history.p2', language.code)}
                </p>
              </div>
            }
            image="/assets/oldakasha.jpg" // Changed image to oldakasha.jpg (ensure path is correct)
            imageAlt={t('about.history.imageAlt', language.code)}
            // Removed textPosition prop to default to left, or specify as needed
          />
          {/* </div> */}

          {/* Separator */}
          <div className="h-[2px] bg-gradient-to-r from-transparent via-neutral-800 to-transparent opacity-50 mt-8 mb-8" /> {/* Added margin to separator */}

          {/* Philosophy Section - Outer glass div removed */}
          {/* <div className="p-8 rounded-[2rem] mb-12 bg-white/10 backdrop-blur-md border border-white/20 shadow-lg"> */}
          <AboutSection 
            title={t('about.philosophy.title', language.code)}
            content={
              <div>
                <p className="mb-4">
                  {t('about.philosophy.p1', language.code)}
                </p>
                <p className="mb-4">
                  {t('about.philosophy.p2', language.code)}
                </p>
                <p>
                  {t('about.philosophy.p3', language.code)}
                </p>
              </div>
            }
            image="/assets/products/Jarrones CARA negro.jpg"
            imageAlt={t('about.philosophy.imageAlt', language.code)}
            textPosition="right" // Explicitly set if needed, or AboutSection handles reverse
          />
          {/* </div> */}

          {/* Separator */}
          <div className="h-[2px] bg-gradient-to-r from-transparent via-neutral-800 to-transparent opacity-50 mt-8 mb-8" /> {/* Added margin to separator */}

        </div>

        {/* Meet the Designer Section - Enlarged */}
        <div id="designer-section" className="py-12 md:py-16">
          <div className="container-custom">
            <h2 className="text-3xl md:text-4xl font-cursive text-akasha-brown text-center mb-10 md:mb-12">
              {t('about.designer.title', language.code)} 
            </h2>
            <motion.div 
              className="max-w-xl mx-auto bg-white/10 backdrop-blur-md border border-white/20 shadow-lg rounded-[2rem] p-6 md:p-8 text-center" // Increased max-w-xl
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="w-48 h-48 md:w-56 md:h-56 mx-auto rounded-full overflow-hidden border-4 border-white/50 shadow-md mb-6"> {/* Increased image size and mb */}
                <img 
                  src="/assets/team/flor.jpeg" 
                  alt={t('about.designer.name', language.code)} 
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-2xl md:text-3xl font-semibold text-akasha-black mb-2">{/* Increased font size for name */}
                {t('about.designer.name', language.code)} 
              </h3>
              <p className="text-md md:text-lg text-akasha-brown font-medium mb-4">{/* Increased font size for role and mb*/}
                {t('about.designer.role', language.code)}
              </p>
              <p className="text-base text-akasha-black/80">{/* Increased font size for bio */}
                {t('about.designer.bio', language.code)}
              </p>
            </motion.div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AboutPage;
